module.exports = __webpack_public_path__ + "img/key.afb733c1.svg";